var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BasePagination",attrs:{"tabindex":"1"}},[_c('pagination',_vm._b({attrs:{"tabindex":"1","background":"","layout":"prev, pager, next","pager-count":5,"prev-text":"<","next-text":">"},on:{"current-change":e => _vm.$emit('current-change', e)}},'pagination',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }